<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/opportunities-icon.svg" alt=""></div>
            <div>
                <h4 class="text-semibold">Nueva Oportunidad</h4>
                <h6 class="color-gray" style="font-weight: 400;">Selecciones el tipo de empresa asociada a esta Oportunidad</h6>
            </div>
            <div>
                <h3 class="color-gray text-semibold">
                    <div class="center-svg">
                        <img (click)="closeModal()" class="close-button" src="assets/svg/close-icon.svg" alt="">
                    </div>
                </h3>
            </div>
    </div>

    <div class="mdl-body">
      <div class="d-flex justify-center gap-20 mt-4">
        <label class="crm-radio-label">
          <input type="radio" class="crm-radio" name="empresa" value="publica" [(ngModel)]="selectedType" (change)="selectType('publica')" />
          <span class="crm-radio-custom"></span>
          Empresa pública
        </label>
        <label class="crm-radio-label">
          <input type="radio" class="crm-radio" name="empresa" value="privada" [(ngModel)]="selectedType" (change)="selectType('privada')" />
          <span class="crm-radio-custom"></span>
          Empresa privada
        </label>
      </div>

        <div class="d-flex justify-center gap-20 mt-5">
        <button class="btn btn-primary-outline" (click)="closeModal()">Cancelar</button>
        <button class="btn btn-primary" [disabled]="!selectedType" (click)="openOpportunityForm()">Siguiente</button>
      </div> 


</div>